import { QueryClient } from "@tanstack/react-query";
import { QUERY_RETRY_COUNT } from "./utils/queryRetry";

/**
 * One client for the app. Logout clears it: CV blobs and other user data are cached with
 * `staleTime: Infinity` and must not be readable by the next person in this tab.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: QUERY_RETRY_COUNT,
		},
	},
});
